import * as React from "react"
import { Global } from "@emotion/react"

const CustomFonts = () => (
  <Global
    styles={`
            /**
             * @license
             *
             * Font Family: Satoshi
             * Designed by: Deni Anggara
             * URL: https://www.fontshare.com/fonts/satoshi
             * © 2021 Indian Type Foundry
             *
             * Font Styles:
             * Satoshi Variable(Variable font)
             * Satoshi Light
             * Satoshi Regular
             * Satoshi Medium
             * Satoshi Bold
             * Satoshi Black
             *
            */
            
            
            /**
            * This is a variable font
            * You can controll variable axes as shown below:
            * font-variation-settings: 'wght' 300.0;
            *
            * available axes:
            
            * 'wght' (range from 300.0 to 900.0)
            
            */
            
            @font-face {
            font-family: 'Satoshi-Variable';
            src: url('../../assets/fonts/Satoshi-Variable.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Variable.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Variable.ttf') format('truetype');
                font-weight: 300 900;
                font-display: swap;
                font-style: normal;
            }
            
            
            @font-face {
            font-family: 'Satoshi-Light';
            src: url('../../assets/fonts/Satoshi-Light.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Light.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Light.ttf') format('truetype');
                font-weight: 300;
                font-display: swap;
                font-style: normal;
            }
            
            
            @font-face {
            font-family: 'Satoshi-Regular';
            src: url('../../assets/fonts/Satoshi-Regular.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Regular.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Regular.ttf') format('truetype');
                font-weight: 400;
                font-display: swap;
                font-style: normal;
            }
            
            
            @font-face {
            font-family: 'Satoshi-Medium';
            src: url('../../assets/fonts/Satoshi-Medium.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Medium.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Medium.ttf') format('truetype');
                font-weight: 500;
                font-display: swap;
                font-style: normal;
            }
            
            
            @font-face {
            font-family: 'Satoshi-Bold';
            src: url('../../assets/fonts/Satoshi-Bold.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Bold.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Bold.ttf') format('truetype');
                font-weight: 700;
                font-display: swap;
                font-style: normal;
            }
            
            
            @font-face {
            font-family: 'Satoshi-Black';
            src: url('../../assets/fonts/Satoshi-Black.woff2') format('woff2'),
                url('../../assets/fonts/Satoshi-Black.woff') format('woff'),
                url('../../assets/fonts/Satoshi-Black.ttf') format('truetype');
                font-weight: 900;
                font-display: swap;
                font-style: normal;
            }
    

            @font-face {
                font-family: 'lexendmedium';
                src: url('../../assets/fonts/lexend-medium-webfont.woff2') format('woff2'),
                     url('../../assets/fonts/lexend-medium-webfont.woff') format('woff');
                font-weight: normal;
                font-style: normal;
            
            }
            
            
            @font-face {
                font-family: 'lexendsemibold';
                src: url('../../assets/fonts/lexend-semibold-webfont.woff2') format('woff2'),
                     url('../../assets/fonts/lexend-semibold-webfont.woff') format('woff');
                font-weight: normal;
                font-style: normal;
            
            }
      `}
  />
)

export default CustomFonts